/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component (filters the tenant's livelli_sci list into
 *              ski/snow/fondo variants for a product)
 *   extends:   Component (@glimmer/component)
 *   template:  list-levels.hbs
 *   args:      @item
 *   uses:      service session
 *   siblings:  level-selector, render-level
 *   tests:     glimmer-getters-test.js
 *
 * Three getters (livelliSci/livelliSnow/livelliFondo) each filter
 * session.option_field.livelli_sci by the product's discipline flags
 * (is_sci/is_snow/is_fondo) and the ecommerce visibility flags.
 */
import Component from '@glimmer/component';

import { service } from '@ember/service';

export default class ListLevelsComponent extends Component {
  @service session;

  get livelliSci() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_sci || (!item?.is_fondo && !item?.is_snow)) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && !l.hideSci);
    }

    return [];
  }

  get livelliSnow() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_snow) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && l.isSnowboard);
    }

    return [];
  }

  get livelliFondo() {
    const livelli_sci = this.session.option_field?.livelli_sci || [];
    const item = this.args.item;

    if (item?.is_fondo) {
      return livelli_sci.filter((l) => !l.hide_ecommerce && l.isFondo);
    }

    return [];
  }
}
